
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import Index from '@/components/Index.vue'
import Travel from '@/components/Travel/Index.vue'
import Consumption from '@/components/consumption/Index.vue'
import Catering from '@/components/catering/Index.vue'
import Transport from '@/components/transport/Index.vue'
import Environment from '@/components/eco/Environment.vue'
import Gdp from '@/components/gdp/gdp.vue'

@Options({
    data () {
        return {
            componentNames: [
                {
                    name: 'Index',
                    color: '#fff'
                },
                {
                    name: 'Travel',
                    color: '#eeffff'
                },
                {
                    name: 'Consumption',
                    color: '#f4eaf1'
                },
                {
                    name: 'Catering',
                    color: '#ebd9c2'
                },
                {
                    name: 'Transport',
                    color: '#f9f2d6'
                },
                {
                    name: 'Environment',
                    color: '#d9eff5'
                },
                {
                    name: 'Gdp',
                    color: '#eadfda'
                }
            ],
            currentIndex: 0,
            startY: 0,
            canChange: true
        }
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData'])
    },
    components: {
        Index,
        Travel,
        Consumption,
        Catering,
        Transport,
        Environment,
        Gdp,
    },
    watch: {
        currentIndex (to, from) {
            this.canChange = false
            window.scrollTo(0, 0)
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 500)
            setTimeout(() => {
                window.scrollTo(0, 0)
                this.canChange = true
            }, 1000)
        }
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
    },
    methods: {
        touchstart (e) {
            if (!this.canChange) {
                e.preventDefault()
                return
            }
            this.startY = e.touches[0].clientY
        },
        touchmove (e) {
            if (!this.canChange) {
                e.preventDefault()
                return
            }
            const currentY = e.touches[0].clientY;
            if (currentY > this.startY) {
                // if (this.currentIndex > 0 && document.documentElement.scrollTop === 0) {
                //     this.currentIndex--
                // }
            } else {
                if (this.currentIndex < this.componentNames.length - 1 && document.documentElement.scrollTop + window.innerHeight + 10 >= document.documentElement.scrollHeight) {
                    this.currentIndex++
                }
            }
            this.startY = currentY
        },
        touchend (e) {
            if (!this.canChange) {
                e.preventDefault()
                return
            }
            this.startY = 0
        },
    }
})
export default class Home extends Vue {}
